import BaseClient, { type ExtendedAxiosRequestConfig } from '../BaseClient';
import type { QueryParams } from '~/services/api';
import type { Group, GroupsClientInterface } from './groupsClient.types';

export default class CorporateGroupsClient extends BaseClient implements GroupsClientInterface {
    constructor(private teamId: number) {
        super();
    }

    getGroups(params?: QueryParams, config?: ExtendedAxiosRequestConfig) {
        const url = `/api/v3/teams/${this.teamId}/groups`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    countGroups() {
        const url = `/api/v3/teams/${this.teamId}/groups/count`;
        return this.makeCoreApiRequest(url, 'get');
    }

    countGroupsByStatus(config?: ExtendedAxiosRequestConfig) {
        const url = `/api/v3/teams/${this.teamId}/groups/count/status`;
        return this.makeCoreApiRequest(url, 'get', null, null, config);
    }

    getGroup(groupId: string) {
        const url = `/api/v3/teams/${this.teamId}/groups/${groupId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    createGroup(data: Group) {
        const url = `/api/v3/teams/${this.teamId}/groups`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    updateGroup(groupId: string, data: Group) {
        const url = `/api/v3/teams/${this.teamId}/groups/${groupId}`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    deleteGroup(groupId: string) {
        const url = `/api/v3/teams/${this.teamId}/groups/${groupId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getGroupCustomAttributes(groupId: string) {
        const url = `/api/v3/teams/${this.teamId}/groups/${groupId}/custom-attributes`;
        return this.makeCoreApiRequest(url, 'get');
    }

    createGroupCustomAttribute(groupId: string, data: Group) {
        const url = `/api/v3/teams/${this.teamId}/groups/${groupId}/custom-attributes`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    updateGroupCustomAttribute(groupId: string, customAttributeKey: string, data: { key: string; value: string }) {
        const url = `/api/v3/teams/${this.teamId}/groups/${groupId}/custom-attributes/${customAttributeKey}`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    deleteGroupCustomAttribute(groupId: string, customAttributeKey: { key: string; value: string }) {
        const url = `/api/v3/teams/${this.teamId}/groups/${groupId}/custom-attributes/${customAttributeKey}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getGroupGroupCollections(groupId: string) {
        const url = `/api/v3/teams/${this.teamId}/groups/${groupId}/group-collections`;

        return this.makeCoreApiRequest(url, 'get');
    }

    getGroupCustomAttributesMeta() {
        const url = '/api/group_custom_attributes_meta';
        return this.makeCoreApiRequest(url);
    }
}
